export default "__VITE_ASSET__6bldPBCF__"